// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.risk_likelihood_enum */
var RiskLikelihoodEnum;
(function (RiskLikelihoodEnum) {
    RiskLikelihoodEnum["LOW"] = "LOW";
    RiskLikelihoodEnum["MEDIUM"] = "MEDIUM";
    RiskLikelihoodEnum["HIGH"] = "HIGH";
})(RiskLikelihoodEnum || (RiskLikelihoodEnum = {}));
;
export default RiskLikelihoodEnum;
/** Zod schema for risk_likelihood_enum */
export const riskLikelihoodEnum = z.nativeEnum(RiskLikelihoodEnum);
//# sourceMappingURL=RiskLikelihoodEnum.js.map